import { createSlice } from "@reduxjs/toolkit";

// Define the initial state of the thread
const initialState = {
    isLoaderActive: false,
    allThreads: [],
    selectedThread: null,
    searchText: "",
    threadListActiveView: "all",
    threadTypeFilter: null, // null means no filter (all types), "room" or "individual" to filter
    pagination: {
        limit: 50,
        totalPages: 1,
        page: -1,
        hasNextPage: true,
    },
};

// Create a slice for user-related state
const threadSlice = createSlice({
  name: "threadStore",
  initialState,
  reducers: {
    setLoaderActive: (state, action) => {
        state.isLoaderActive = action.payload;
    },
    setAllThreads: (state, action) => {
        state.allThreads = action.payload;
    },
    appendThreads: (state, action) => {
        state.allThreads = [...state.allThreads, ...action.payload];
    },
    setSelectedThread: (state, action) => {
        state.selectedThread = action.payload;
    },
    setSearchText: (state, action) => {
        state.searchText = action.payload;
    },
    setThreadListActiveView: (state, action) => {
        state.threadListActiveView = action.payload;
    },
    setThreadTypeFilter: (state, action) => {
        state.threadTypeFilter = action.payload;
    },
    setPagination: (state, action) => {
        state.pagination = action.payload;
    }
  },
});

// Export the actions directly for usage without dispatching manually
const { 
    setLoaderActive, 
    setAllThreads, 
    appendThreads,
    setSelectedThread, 
    setSearchText, 
    setThreadListActiveView,
    setThreadTypeFilter,
    setPagination
 } = threadSlice.actions;

// Create a ThreadStore object that automatically dispatches actions
export const ThreadStoreActions = {
    setLoaderActive,
    setAllThreads,
    appendThreads,
    setSelectedThread,
    setSearchText,
    setThreadListActiveView,
    setThreadTypeFilter,
    setPagination
};

// Export the reducer to be used in the store
export const ThreadStoreReducer = threadSlice.reducer;
